import { getAmplitudeInstance } from '../amplitudeHelpers';
import AdSource from '../enums/AdSource';

type logRemoveAdClickedParams = {
  adunitpath?: string;
  advertiser?: string;
  advertiser_id?: number;
  location: AdSource;
};

/**
 * The user clicks to remove an ad
 * @param params - Attributes to log with the amplitude event
 * @param params.adunitpath - Identifies the placement of the ad
 * @param params.advertiser - Identifies the advertiser of the ad
 * @param params.advertiser_id - The ID of the advertiser of the ad
 * @param params.location - Identifies the location of the ad
 */
const logRemoveAdClicked = ({ adunitpath, advertiser, advertiser_id, location }: logRemoveAdClickedParams, callback?: () => void) => {
  getAmplitudeInstance().logEvent('remove ad clicked', { adunitpath, advertiser, 'advertiser id': advertiser_id, location }, callback);
};

export default logRemoveAdClicked;
